import React from 'react';
import { Route, Switch } from 'react-router-dom';
import LegacyAuditRedirect from 'modules/Audit/pages/LegacyAuditRedirect';

/**
 * Old `/audit/:grantId` links (verifier-firm-foundation phase 5). Every live audit grant became a
 * verification engagement, so both the diagram and the plan link now resolve to the engagement
 * that replaced the grant. Mounted by _app.jsx when the URL matches /audit/* — signed in, before
 * OrgBoundary (see LegacyAuditRedirect).
 */
const AuditRoutes = () => (
  <Switch>
    <Route
      path="/audit/:grantId/plan"
      exact
      component={LegacyAuditRedirect}
    />
    <Route
      path="/audit/:grantId"
      exact
      component={LegacyAuditRedirect}
    />
  </Switch>
);

export default AuditRoutes;
